import React from "react";
import { Accordion } from "luna-react/components/accordion";

export class AccordionItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }
  render() {
    const { children, title } = this.props;
    const { isOpen } = this.state;
    return (
      <Accordion
        standalone={false}
        title={title}
        open={isOpen}
        titleElement="h3"
      >
        {children}
      </Accordion>
    );
  }
}

export default AccordionItem;



// WEBPACK FOOTER //
// ./src/components/common/AccordionItem.js